export const getQueryString = (key: string) => {
  if (typeof window === 'undefined' || key === '') {
    return
  }

  const params = new URLSearchParams(window.location.search)
  return params.get(key)
}
